import * as React from "react";
import {
  GettingStartedSkills,
  type SuggestedSkillsSelectionState,
} from "../../shared/components/GettingStartedSkills";

export interface ExcelEmptyStateProps extends Partial<SuggestedSkillsSelectionState> {
  manageSkillsUrl?: string;
  onSelectSuggestedSkill?: (path: string) => void;
}

export const ExcelEmptyState: React.FC<ExcelEmptyStateProps> = ({
  manageSkillsUrl,
  availableSkillSlugs,
  selectedSkillSlugs,
  selectionAtLimit,
  onSelectSuggestedSkill,
}) => {
  return (
    // Centring and spacing belong to `GettingStartedSkills`, which sizes
    // itself against the height this column gets. `min-h-0` lets that column
    // shrink inside the chat scroll container rather than forcing it to
    // overflow.
    <div className="flex min-h-0 flex-1 flex-col">
      <GettingStartedSkills
        host="excel"
        manageSkillsUrl={manageSkillsUrl}
        availableSkillSlugs={availableSkillSlugs}
        selectedSkillSlugs={selectedSkillSlugs}
        selectionAtLimit={selectionAtLimit}
        onSelectSuggestedSkill={onSelectSuggestedSkill}
      />
    </div>
  );
};
